import { createFileRoute } from "@tanstack/react-router";
import { JaziaVerifyOtp } from "@/components/verify/JaziaVerifyOtp";

export const Route = createFileRoute("/verify-otp")({
  component: JaziaVerifyOtp,
});
